export const messages_lt = {
    nameEmpty: "Vardas negali būti tuščias.",
    emailEmpty: "El. pašto adresas negali būti tuščias.",
    emailNotValid: "El. pašto adresas nėra galiojantis, prašome įvesti tinkamą el. pašto adresą.",
    locationEmpty: "Vieta negali būti tuščia.",
    interests: "Pasirinkite 3 kategorijas.",
    profileSaved: "Profilio informacija išsaugota.",
    profilePic: "Profilio nuotrauka išsaugota.",
    addToFavorites: "Sėkmingai pridėta prie mėgstamiausių.",
    removeFromFavorites: "Sėkmingai pašalinta iš mėgstamiausių."
};


// WEBPACK FOOTER //
// ./src/constants/messages_lt.js